import { useState } from "react";
import { Box, Collapse, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { SectionPaper } from "@/components/Paper";
import { Divider } from "@/components/Divider";

interface Props {
  /** 見出しの既定は「検索条件」 */
  title?: string;
  /** 初期状態で開いておくか（既定は開） */
  defaultOpen?: boolean;
  children: React.ReactNode;
}

/** 見出し行のボタンで開閉する共通の検索条件カード */
export const SearchConditionCard: React.FC<Props> = (props) => {
  const { title = "検索条件", defaultOpen = true, children } = props;
  const [open, setOpen] = useState<boolean>(defaultOpen);

  const toggle = (): void => {
    setOpen((prev) => !prev);
  };

  return (
    <SectionPaper>
      {/* 見出し行を単一のbuttonにし、クリック・キー操作とフォーカス位置を統一する */}
      <Box
        component="button"
        type="button"
        onClick={toggle}
        aria-expanded={open}
        aria-label={open ? "検索条件を閉じる" : "検索条件を開く"}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          px: { xs: 2, sm: 3, md: 4 },
          pt: 2,
          pb: 1.25,
          cursor: "pointer",
          border: "none",
          background: "none",
          font: "inherit",
          color: "inherit",
          textAlign: "left",
        }}
      >
        <Typography sx={{ fontSize: "1rem", fontWeight: 700 }}>
          {title}
        </Typography>
        <ExpandMoreIcon
          aria-hidden
          sx={{
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s",
          }}
        />
      </Box>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box sx={{ mx: { xs: 2, sm: 3, md: 4 } }}>
          <Divider />
        </Box>
        {children}
      </Collapse>
    </SectionPaper>
  );
};
